import styled from 'styled-components'

export const AddGroupButtonWithModalStyles = styled.div`
  position: sticky;
  right: 0;
  bottom: 1.6rem;
`
